import * as stylex from "@stylexjs/stylex";
import { copy } from "@/copy";
import type { Breakpoint } from "@/domain/breakpoint";
import "@/theme/seasons.stylex";
import { season } from "@/theme/seasons.stylex";
import "@/theme/tokens.stylex";
import { colors, motion, radii, space } from "@/theme/tokens.stylex";
import { Skeleton, SkeletonBlock } from "@/ui/Skeleton";
import { weatherLayout } from "../layout";
const styles = {
  grid: {
    k1xSpc: "xrvj5dj",
    kOIVth: "x1ur044a",
    $$css: true
  }
};
const bar = (width: number) => <SkeletonBlock width={width} height={14} radius="4px" />;
export function WeatherSkeleton({
  breakpoint
}: {
  breakpoint: Breakpoint;
}) {
  return <Skeleton label={copy.weather.loading} xstyle={[styles.grid, weatherLayout(breakpoint).grid]}>
      <div className="xg0is8a xwe7p7i xc0ge15 x15406qy x11l8gmq x1eyvnp3 x1ipa8oz x9f619 x78zum5 xdt5ytf x1qughib x1ur044a">
        {bar(160)}
        <div className="x78zum5 x1qughib x6s0dn4 xddi9bj">
          <SkeletonBlock width={180} height={96} radius="12px" />
          <SkeletonBlock width={96} height={96} radius={radii.full} />
        </div>
        <div className="xrvj5dj xnby9oq xddi9bj">
          {[0, 1, 2, 3].map(detail => <SkeletonBlock key={detail} height={48} radius={radii.md} />)}
        </div>
      </div>
      <div className="x78zum5 xdt5ytf x1ur044a xeuugli">
        <div className="x5r8ks9 x1fv5t7x x14nwjz3" />
        <div className="x78zum5 xdt5ytf x1hu4l6k">
          {bar(140)}
          <div className="x5r8ks9 x1fv5t7x x1h5wmu3" />
        </div>
        <div className="x78zum5 xdt5ytf x1hu4l6k x1iyjqo2">
          {bar(140)}
          <div className="x5r8ks9 x1iyjqo2 x1ficeh5 xwe7p7i" />
        </div>
      </div>
    </Skeleton>;
}